<template>
    <div v-select-text="value" style="background-color: #fff; max-width: 800px; margin: 0 auto; border: 2px solid #000; padding: 20px; font-family: 'Times New Roman'">
        <table cellpadding="0" cellspacing="0" border="0" width="100%">
            <tbody>
                <tr>
                    <td width="50%" valign="top">
                        <div style="text-align: center; margin-right: 50px;">
                            <img width="200" style="filter: grayscale(100%); -webkit-filter: grayscale(100%);" src="./i1.png"/><br/>
                            <div style="font-size: 12px;">
                                <div>Завод металлопластиковых конструкций</div>
                                <div>"Чемпион"</div>
                                тел.: 624-43-54; 521-94-29; 983-42-68
                                <br><br>
                            </div>
                            <div style="text-align: center; font-weight: bold;">Заказчик</div>
                            <div style="position: relative; border-bottom: 1px solid #000; height: 30px;">
                                <span style="position: absolute; left: 20px; top: -5px; color: blue; font-size: 22px; font-style: italic; font-family: 'Comic Sans MS'">Иванов И.И.</span>
                            </div>
                            <div style="text-align:left; position: relative; border-bottom: 1px solid #000; height: 30px;">
                                Паспорт:
                                <span style="position: absolute; left: 80px; top: -3px; color: blue; font-style: italic; font-size: 20px; font-family: 'Comic Sans MS'">4534 348633</span>
                            </div>
                            <div style="text-align:left; position: relative; border-bottom: 1px solid #000; height: 30px;">
                                Выдан:
                                <span style="position: absolute; left: 80px; top: -3px; color: blue; font-style: italic; font-size: 20px; font-family: 'Comic Sans MS'">28.07.1964г.</span>
                            </div>
                            <div style="text-align:left; position: relative; border-bottom: 1px solid #000; height: 30px;">
                                Тел:
                                <span style="position: absolute; left: 50px; top: -3px; color: blue; font-style: italic; font-size: 20px; font-family: 'Comic Sans MS'">574-34-66</span>
                            </div>
                        </div>



                    </td>
                    <td width="50%" valign="top">
                        <div style="font-size: 20px; text-align: center; font-weight: bold; text-transform: uppercase;">Гарантийный талон</div>
                        <div style="display: inline-block; font-size: 18px; text-align: center; position: relative;">
                            К заказу _________________
                            <span style="position: absolute; right: 20px; top: -5px; color: blue; font-style: italic; font-size: 22px; font-family: 'Comic Sans MS'">4600000</span>
                        </div>
                        <div style="font-size: 18px;">Тел. сервиской службы: <span style="border-bottom: 1px solid #000; padding-left: 50px">521-94-29</span></div>
                        <br/><br/><br/>
                        <div style="text-align: center; font-weight: bold;">Исполнитель</div>
                        <div style="font-size: 16px;">
                            Наименование: ООО "ВекТор"<br/>
                            Адрес: Спб. пр.Косыгина д.21<br/>
                            ИНН: 38233243232423<br/>
                            Р/с: 144324234234324324334<br/>
                            К/с: 344573443532132343536<br/>
                            БИК: 453422133<br/>
                            ОКПО: 365342412<br/>
                            КПП: 54643412<br/>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <div style="overflow: hidden; height: 180px; width: 100%; position: relative; text-align: right">
            <img width="160" style="transform: rotate(-30deg); position: absolute; top: 10px; left: 80px;" src="./i2.gif"/>
            <br><br>
            <hr style="display: inline-block;" size="1" color="#000" width="60%"/>
            <hr style="display: inline-block;" size="1" color="#000" width="60%"/>
            <hr style="display: inline-block;" size="1" color="#000" width="60%"/>
            <hr style="display: inline-block;" size="1" color="#000" width="60%"/>
        </div>
    </div>
</template>

<script>
    import SelectText from '@/directives/select-text.js'

    export default {
        props: {
            value: [Array]
        },
        directives: {
            SelectText
        }
    }
</script>